import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetExternalTrainingModulesPlayerResponse = {
   external_training_moduleid: number;
   title: string;
   launchLink: string;
};

export async function getExternalTrainingModulesPlayer(
   external_training_moduleid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetExternalTrainingModulesPlayerResponse> {
   return makeRequest('get', `/external_training_modules/${external_training_moduleid}/player`, {
      ...common,
   });
}
